// AUTO-GENERATED from content/consumables/effects.toml (h2kdb) — do not edit.
// Ability effects (lane A, 2026-06-30). Every effect row authored in h2kdb is
// emitted; compile fails if a consumable names an effect that is not defined.

export type EffectType = 'damage' | 'heal' | 'dot' | 'hot' | 'stun' | 'slow' | 'knockback' | 'silence' | 'root' | 'buff' | 'debuff' | 'shield' | 'dispel' | 'summon' | 'teleport';
export type RestoreResource = 'health' | 'mana';
export type EffectReplacementPolicy = 'replace';
export type DestinationPolicy = 'run_origin' | 'bound_town' | 'nearest_safe_town' | 'fixed_destination';

export interface AbilityEffectDataDef {
  id: string;
  name: string;
  effectType: EffectType;
  baseValue: number;
  /** For buff rows: additive stat modifiers applied while the aura is active. */
  statBonuses?: Record<string, number>;
  school?: string;
  scalingStat?: string;
  scalingFactor?: number;
  /** Seconds. For hot/dot, total duration. 0 = instant. */
  durationSec: number;
  /** Seconds between ticks. 0 = no ticking (instant / one-shot). */
  tickIntervalSec: number;
  procChance: number;
  /** For heal/hot rows: which resource the row restores. */
  restoreResource?: RestoreResource;
  /** For buff rows: the aura identifier applied to the consumer. When
   *  absent, the effect id itself is the aura id (helix_3d pattern). */
  auraId?: string;
  /** Mutually-exclusive aura family. The newest replace member wins. */
  exclusiveGroup?: string;
  replacementPolicy?: EffectReplacementPolicy;
  /** Final server-owned scalar applied to player-owned outgoing damage. */
  outgoingDamageMultiplier?: number;
  /** Server-owned destination rule for teleport effects. */
  destinationPolicy?: DestinationPolicy;
  tags?: string[];
}

export const ABILITY_EFFECT_DATABASE: Record<string, AbilityEffectDataDef> = {
  'restore_health_50': {
    id: 'restore_health_50',
    name: 'Restore 50 Health',
    effectType: 'heal',
    baseValue: 50,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'health',
  },
  'restore_health_150': {
    id: 'restore_health_150',
    name: 'Restore 150 Health',
    effectType: 'heal',
    baseValue: 150,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'health',
  },
  'restore_mana_50': {
    id: 'restore_mana_50',
    name: 'Restore 50 Mana',
    effectType: 'heal',
    baseValue: 50,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'mana',
  },
  'restore_mana_30': {
    id: 'restore_mana_30',
    name: 'Restore 30 Mana',
    effectType: 'heal',
    baseValue: 30,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'mana',
  },
  'restore_health_full': {
    id: 'restore_health_full',
    name: 'Full Health Restore',
    effectType: 'heal',
    baseValue: 99999,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'health',
  },
  'restore_mana_full': {
    id: 'restore_mana_full',
    name: 'Full Mana Restore',
    effectType: 'heal',
    baseValue: 99999,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'mana',
  },
  'heal_over_time_100': {
    id: 'heal_over_time_100',
    name: 'Bandage Heal 100',
    effectType: 'hot',
    baseValue: 100,
    durationSec: 8,
    tickIntervalSec: 2,
    procChance: 1,
    restoreResource: 'health',
  },
  'buff_speed_60': {
    id: 'buff_speed_60',
    name: 'Speed Elixir Aura',
    effectType: 'buff',
    baseValue: 20,
    statBonuses: {"speed":20},
    durationSec: 60,
    tickIntervalSec: 0,
    procChance: 1,
  },
  'buff_fortitude_100': {
    id: 'buff_fortitude_100',
    name: 'Fortitude Elixir Aura',
    effectType: 'buff',
    baseValue: 100,
    statBonuses: {"hp":100},
    durationSec: 60,
    tickIntervalSec: 0,
    procChance: 1,
  },
  'buff_titans_allstats': {
    id: 'buff_titans_allstats',
    name: 'Flask of the Titans Aura',
    effectType: 'buff',
    baseValue: 5,
    statBonuses: {"strength":5,"dexterity":5,"intelligence":5,"luck":5},
    durationSec: 1800,
    tickIntervalSec: 0,
    procChance: 1,
    exclusiveGroup: 'primary_flask',
    replacementPolicy: 'replace',
  },
  'buff_speed_runner': {
    id: 'buff_speed_runner',
    name: 'Speed Runner Aura',
    effectType: 'buff',
    baseValue: 5,
    statBonuses: {"strength":5,"dexterity":5,"intelligence":5,"luck":5},
    durationSec: 1800,
    tickIntervalSec: 0,
    procChance: 1,
    exclusiveGroup: 'primary_flask',
    replacementPolicy: 'replace',
    tags: ['runner', 'speedrun'],
  },
  'buff_slow_runner': {
    id: 'buff_slow_runner',
    name: 'Slow Runner Aura',
    effectType: 'buff',
    baseValue: 0,
    durationSec: 1800,
    tickIntervalSec: 0,
    procChance: 1,
    exclusiveGroup: 'primary_flask',
    replacementPolicy: 'replace',
    outgoingDamageMultiplier: 0.4,
    tags: ['runner', 'balance', 'practice_only'],
  },
  'teleport_run_origin': {
    id: 'teleport_run_origin',
    name: 'Return to the Waking Tomb',
    effectType: 'teleport',
    baseValue: 0,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    destinationPolicy: 'run_origin',
    tags: ['travel', 'runner'],
  },
  'teleport_bound_town': {
    id: 'teleport_bound_town',
    name: 'Return to the Last Safe Settlement',
    effectType: 'teleport',
    baseValue: 0,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    destinationPolicy: 'bound_town',
    tags: ['travel', 'return_scroll'],
  },
  'buff_attack_10': {
    id: 'buff_attack_10',
    name: 'Attack Scroll Aura',
    effectType: 'buff',
    baseValue: 10,
    statBonuses: {"attack":10},
    durationSec: 300,
    tickIntervalSec: 0,
    procChance: 1,
  },
  'buff_defense_10': {
    id: 'buff_defense_10',
    name: 'Defense Scroll Aura',
    effectType: 'buff',
    baseValue: 10,
    statBonuses: {"defense":10},
    durationSec: 300,
    tickIntervalSec: 0,
    procChance: 1,
  },
  'buff_experience_2x': {
    id: 'buff_experience_2x',
    name: 'Experience Scroll Aura',
    effectType: 'buff',
    baseValue: 2,
    durationSec: 1800,
    tickIntervalSec: 0,
    procChance: 1,
  },
  'dispel_poison': {
    id: 'dispel_poison',
    name: 'Remove Poison',
    effectType: 'dispel',
    baseValue: 0,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    tags: ['poison'],
  },
  'restore_health_70': {
    id: 'restore_health_70',
    name: 'Restore 70 Health',
    effectType: 'heal',
    baseValue: 70,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'health',
    tags: ['consumable', 'classic'],
  },
  'restore_health_140': {
    id: 'restore_health_140',
    name: 'Restore 140 Health',
    effectType: 'heal',
    baseValue: 140,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'health',
    tags: ['consumable', 'classic'],
  },
  'restore_health_300': {
    id: 'restore_health_300',
    name: 'Restore 300 Health',
    effectType: 'heal',
    baseValue: 300,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'health',
    tags: ['consumable', 'classic'],
  },
  'restore_mana_70': {
    id: 'restore_mana_70',
    name: 'Restore 70 Mana',
    effectType: 'heal',
    baseValue: 70,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'mana',
    tags: ['consumable', 'classic'],
  },
  'restore_mana_140': {
    id: 'restore_mana_140',
    name: 'Restore 140 Mana',
    effectType: 'heal',
    baseValue: 140,
    durationSec: 0,
    tickIntervalSec: 0,
    procChance: 1,
    restoreResource: 'mana',
    tags: ['consumable', 'classic'],
  },
};

export function getAbilityEffect(id: string): AbilityEffectDataDef | undefined {
  return ABILITY_EFFECT_DATABASE[id];
}
